module.exports = __webpack_public_path__ + "img/Monte_Kope_75.3b9cbf62.jpg";